export default __webpack_public_path__ + "assets/images/ca03920f8c6d3d3474f9acbb885a2e35.jpg";